import { WASTAGE_COPY } from 'src/constants/wastage'
import { createWastageEntry } from 'src/utils/wastageApi'

/**
 * One Waste entry per dish. The count refresh puts that quantity on the ingredient lines.
 */
export const wastedRecipeEntryBodies = (rows, { reason, businessDate } = {}) =>
  (Array.isArray(rows) ? rows : [])
    .filter(row => Number(row?.qtySold) > 0 && row?.recipeId)
    .map(row => ({
      kind: 'recipe',
      recipeId: String(row.recipeId),
      inputQty: Number(row.qtySold),
      inputUnit:
        row.unitType === WASTAGE_COPY.fullRecipe
          ? WASTAGE_COPY.fullRecipe
          : WASTAGE_COPY.portions,
      reason,
      businessDate,
    }))

export async function recordWastedRecipes({
  venueId,
  rows,
  reason,
  businessDate,
  createEntry = createWastageEntry,
}) {
  if (!reason) return { ok: false, error: 'reason' }
  const bodies = wastedRecipeEntryBodies(rows, { reason, businessDate })
  if (!bodies.length) return { ok: false, error: 'empty' }
  const created = []
  for (const body of bodies) {
    created.push(await createEntry(venueId, body))
  }
  return { ok: true, created }
}
